import * as moment from 'moment';

import {DATE_FORMAT} from '../../../app.constants';

export const WHITE = '#ffffff';

export const COLOR1 = '#909497';

export const COLOR2 = '#303f9f';

export const COLOR3 = '#6cc788';

export const COLOR4 = '#fce605';

export const COLOR5 = '#f44455';

export const COLOR6 = '#d4efdf';

export const COLOR7 = '#f5b7b1';

export const COLOR8 = '#3a87ad';

export const scale = (input: number): number => Math.round(input * 100) / 100;

export const getRangesForEstimation = (startDate: string, monthCount: number): Array<{ beginDate: string, endDate: string }> => {
  // find a way to make this configurable and related to the list of pay accus in accrual config
  // I mean, maybe accu are not calculated for one month
  const ranges: Array<{ beginDate: string, endDate: string }> = [];
  for (let i: number = 0; i <= monthCount; i++) {
    const currentMonth = moment(startDate).add('month', i);
    ranges.push({
      beginDate: currentMonth.startOf('month').format(DATE_FORMAT),
      endDate: currentMonth.endOf('month').format(DATE_FORMAT)
    });
  }
  return ranges;
};
